import { createFileRoute } from "@tanstack/react-router";

import type { ChildRouteContext } from "@/root";

import Entry from "@/modules/handbook/user/components/Entry";
import { fetchEntryQueryOptions } from "@/modules/handbook/user/services";

export const Route = createFileRoute("/_panel/_handbook/handbook/entries/$id")({
  component: Component,
  parseParams: (params) => ({
    id: Number(params.id),
  }),
  stringifyParams: ({ id }) => ({ id: `${id}` }),
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("View", { ns: "core.shared" }),
        },
      ],
    }) satisfies ChildRouteContext,
  loader: (opts) =>
    opts.context.queryClient.ensureQueryData(
      fetchEntryQueryOptions(opts.params.id),
    ),
});

function Component() {
  const { id } = Route.useParams();

  return <Entry id={id} />;
}
